import * as angular from "angular";
import { EventModel } from "../../models/event.model";
import { PermissionCheck } from "../../shared/permission";
import { EventDataProvider } from "../../data-provider/event.dp";
import { Utils } from "../../helper/utils.helper";

let EventsComponent = {
    selector: "vcEvents",
    templateUrl: "/angular/components/event/events.component.html",
    bindings: {},
    controller: class EventsController {
        public isLeaderView: boolean;
        public loading = false;
        public pastLoading = true;
        public upcomingLoading = true;
        public activeTab = "upcoming";
        public upcomingEvents: EventModel[] | null = null;
        public pastEvents: EventModel[] | null = null;

        private dataProvider: EventDataProvider;
        public permissionProvider: PermissionCheck;

        constructor(
            __app_type: string,
            EventDataProvider: EventDataProvider,
            Utils: Utils,
            PermissionCheck: PermissionCheck
        ) {
            Utils.accessCheck();
            Utils.runWootric();

            this.dataProvider = EventDataProvider;
            this.permissionProvider = PermissionCheck;

            this.isLeaderView = __app_type == "LEADER";
            this.getUpcomingEvents();
            this.getPastEvents();
        }

        getUpcomingEvents(): void {
            this.dataProvider
                .user({ start: new Date() })
                .then((events: EventModel[]) => {
                    this.upcomingEvents = events;
                    this.upcomingLoading = false;
                });
        }

        getPastEvents(): void {
            this.dataProvider
                .user({ end: new Date() })
                .then((events: EventModel[]) => {
                    this.pastEvents = events;
                    this.pastLoading = false;
                });
        }
    },
};

angular.module("event").component(EventsComponent.selector, EventsComponent);
